import React, { Component } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import Loader from 'react-loader-spinner';
import ReactPaginate from 'react-paginate';
import DishItems from './DishItems';
import { getTags } from '../../../actions/tags/getTags';
import { getAllMealTypes } from '../../../actions/getAllMealTypes';
import { filterDish, getProducts } from '../../../actions/dishSearch';
import { editDish, createDish, editSelectedDish, cancelEditDish } from '../../../actions/dishEdit';
import { confirmDeletingDish, deleteDish, cancelDeletingDish } from '../../../actions/dishDelete';
import { getDishTemplate } from '../../../actions/dishTemplate';
import DeleteConfirmPopup from '../../Common/DeleteConfirmPopup';
import AddDishButton from './AddDishButton';

class DishesList extends Component {
  componentDidMount() {
    const {
      tags,
      getTags,
      getAllMealTypes,
      getDishTemplate,
      filterDish,
      searchParam,
      filterParam,
      order,
      getProducts,
    } = this.props;
    const { sortParam } = this.props;
    const sort = sortParam.slice(0, -1);
    filterDish(searchParam, filterParam, sort, order, true);
    !tags.length && getTags();
    getAllMealTypes();
    getDishTemplate();
    getProducts(); // get products
  }

  confirmDeleting = (event, name, id) => {
    event.stopPropagation();
    const { confirmDeletingDish } = this.props;
    confirmDeletingDish(name, id);
  };

  deleteDish = (id) => {
    const { deleteDish } = this.props;
    deleteDish(id);
  };

  handlePageClick = (pageNumber) => {
    const { filterDish, searchParam, filterParam, order, sortParam } = this.props;
    const sort = sortParam.slice(0, -1);
    filterDish(searchParam, filterParam, sort, order, pageNumber.selected + 1, true);
  };

  render() {
    const {
      dishes,
      searchedDishes,
      renderingResult,
      showDeleteDishConfirmPopup,
      deletingDishName,
      deletingDishId,
      cancelDeletingDish,
      tags,
      mealTypes,
      dishTemplate,
      isLoadDishes,
      totalDishesPages,
      currentDishesPage,
    } = this.props;

    const handleEditDish = (event, data, newDish) => {
      let dish = data;
      if (!data) {
        dish = {
          name: '',
          calories: '',
          recepie: '',
          min_weight: '',
          avg_weight: '',
          max_weight: '',
          tags: [],
        };
      }
      const payload = {
        dish: dish,
        tags,
        mealTypes,
      };
      event.stopPropagation();
      const { editDish } = this.props;
      editDish(data, newDish, payload);
    };
    const handleCreateDish = () => {
      const { getDishTemplate, editDish, dishTemplate } = this.props;
      getDishTemplate();
      editDish(dishTemplate, true);
    };

    return (
      <List>
        {!isLoadDishes && (
          <DishItems
            dishes={dishes}
            searchedDishes={searchedDishes}
            renderingResult={renderingResult}
            editDish={handleEditDish}
            confirmDeleting={this.confirmDeleting}
          />
        )}
        {isLoadDishes && <Loader type="Ball-Triangle" color="#3a3a3a" height="60" width="60" />}
        <ReactPaginate
          pageCount={totalDishesPages}
          forcePage={currentDishesPage - 1}
          onPageChange={this.handlePageClick}
          previousLabel="<"
          nextLabel=">"
          breakLabel="..."
          marginPagesDisplayed={3}
          pageRangeDisplayed={3}
          previousLinkClassName="prev-page-btn"
          nextLinkClassName="next-page-btn"
          containerClassName="pagination"
          activeLinkClassName="active-page-btn"
          pageLinkClassName="page-btn"
          breakClassName="break-me"
        />
        {showDeleteDishConfirmPopup && (
          <DeleteConfirmPopup
            isOpen={showDeleteDishConfirmPopup}
            title={deletingDishName}
            onDelete={() => this.deleteDish(deletingDishId)}
            onCancel={cancelDeletingDish}
          />
        )}

        <AddDishButton dish={dishTemplate} createDish={handleCreateDish} />
      </List>
    );
  }
}

const mapStateToProps = (state) => {
  const { dishes, isLoadDishes } = state.reducers;
  const { searchedDishes, renderingResult, totalDishesPages, currentDishesPage } = state.dishSearch;
  const { showDeleteDishConfirmPopup, deletingDishName, deletingDishId } = state.dishDelete;
  const { searchParam, filterParam, sortParam, order } = state.searchParams;
  const {
    selectedDish,
    showEditPopup,
    createNewDish,
    editSelectedDish,
    creatingNewDish,
  } = state.dishEdit;
  const { tags } = state.getTags;
  const { mealTypes } = state.getAllMealTypes;
  const { dishTemplate } = state.dishTemplate;

  return {
    dishes,
    tags,
    mealTypes,
    searchedDishes,
    renderingResult,
    showDeleteDishConfirmPopup,
    deletingDishName,
    deletingDishId,
    searchParam,
    filterParam,
    sortParam,
    order,
    selectedDish,
    showEditPopup,
    createNewDish,
    editSelectedDish,
    creatingNewDish,
    dishTemplate,
    isLoadDishes,
    totalDishesPages,
    currentDishesPage,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getTags: () => {
      dispatch(getTags());
    },
    getAllMealTypes: () => {
      dispatch(getAllMealTypes());
    },
    cancelEditDish: () => {
      dispatch(cancelEditDish());
    },
    confirmDeletingDish: (name, id) => {
      dispatch(confirmDeletingDish(name, id));
    },
    deleteDish: (id) => {
      dispatch(deleteDish(id));
    },
    cancelDeletingDish: (id) => {
      dispatch(cancelDeletingDish(id));
    },
    filterDish: (searchValue, tags, sortParam, order, rendering) => {
      dispatch(filterDish(searchValue, tags, sortParam, order, rendering));
    },
    editDish: (data, newDish, payload) => {
      dispatch(editDish(data, newDish, payload));
    },
    createDish: (data) => {
      dispatch(createDish(data));
    },
    editSelectedDish: (data) => {
      dispatch(editSelectedDish(data));
    },
    getDishTemplate: () => {
      dispatch(getDishTemplate());
    },
    getProducts: (name) => {
      dispatch(getProducts(name));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(DishesList);

const List = styled.div`
  display: flex;
  flex-flow: column nowrap;
  justify-content: flex-start;
  align-items: center;
  width: 80%;
  margin: 0 auto;
`;



// WEBPACK FOOTER //
// ./src/Components/Dishes/DishesList/DishesList.jsx